import Vue from "vue";
import VueI18n from "vue-i18n";
import cn from "./config/zh-cn";
import hk from "./config/zh-hk";
import en from "./config/en-us";

window.Vue = Vue;
const i18n = new VueI18n({
	locale: localStorage.getItem("locale") || "zh-cn",
	messages: {
		"zh-cn": cn, // 中文
		"zh-hk": hk, // 繁体中文
		"en-us": en // 英文
	},
});
export default i18n;